import script from "./interAUC.vue?vue&type=script&setup=true&lang=js"
export * from "./interAUC.vue?vue&type=script&setup=true&lang=js"

import "./interAUC.vue?vue&type=style&index=0&id=5108d048&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5108d048"]])

export default __exports__